import { render, staticRenderFns } from "./staff-vendor-data-scope.vue?vue&type=template&id=1143af1a&"
import script from "./staff-vendor-data-scope.vue?vue&type=script&lang=js&"
export * from "./staff-vendor-data-scope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "staff-vendor-data-scope.vue"
export default component.exports